export const getTerms = (value) =>
  String(value ?? '')
    .trim()
    .toLowerCase()
    .split(/\s+/)
    .filter(Boolean);

export const containsTerm = (text, terms) => {
  const value = String(text ?? '').toLowerCase();

  return terms.some((term) => value.includes(term));
};
